import React, { useEffect, useRef, useState } from 'react';
import { NewHeader } from '~/components/NewHeader';
import { Categories } from '~/components/BalconyPageComponents/Categories';
import { BalconyProducts } from '~/components/BalconyPageComponents/BalconyProducts';
import { BalconyPaymentArea } from '~/components/BalconyPageComponents/BalconyPaymentArea';
import { useMenu } from '~/context/OrderingSystem/Menu';

import { FaCashRegister, FaSearch, FaTimes } from 'react-icons/fa';
import { Hyperlink, IconInput, Button } from 'ui-kit-takeat';
import { IoIosArrowBack } from 'react-icons/io';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { SelectComplements } from '~/components/SelectComplements';
import { useCart } from '~/context/OrderingSystem/Cart';
import { ModalConfirmation } from '~/components/ModalConfirmation';
import useBarcodeScanner from '~/hooks/useBarcodeScanner';
import GetDemoButton from '~/components/Buttons/GetDemoButton';
import { useAuth } from '~/context/AuthContext';
import OpeningBox from '../Financial/CashManagementPage/OpeningBox';
import {
  BackLink,
  BalconyCard,
  BalconyProductsContainer,
  MenuArea,
  ModalCashier,
  ModalErrorNF,
  PageContainer,
  PaymentArea,
} from './styles';
import { useBalcony } from '~/hooks';
import { BalconyPaymentAreaPinpad } from '~/components/BalconyPageComponents/BalconyPaymentAreaPinpad';
import toast from 'react-hot-toast';

const BalconyPage = () => {
  const {
    balconySession,
    currentPaymentFlow,
    handleCloseTableBill,
    handleBalconyOrder,
    savePaymentAsync,
    getTableId,
    tableId,
    handleStartPinpadPayment,
    pinpadHealthStatus,
    pinpadPaymentStatus,
    handleCancelPinpadPayment,
    handleResetPinpadOperation,
    handleSwitchPinpadCancelStatus,
    handleChoosePayWithPinpad,
    isChoosePinpad,
    isLeavingPayment,
    isLoadingPayment,
    handleSelectedPaymentComponent,
    isSelectedPaymentComponent,
    isOpenBackToOrder,
    handleSubmitRefactoryOrderBasket,
    isBalconyProductsBlocked,
    handleCancelPaymentCancelation,
    paymentsData,
    getPayments,
    handleUpdateCashbackValue,
    ...balconyProps
  } = useBalcony();

  const { menu } = useMenu();
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      if (!user?.has_balcony && user?.has_balcony !== undefined) {
        history.push('/operation');
      }
    }
  }, [user]);

  const isBalconyPinpad = user.user_use_pinpad && user.use_pinpad;
  const page = window.location.pathname;
  const path = page.split('/')[1];
  const is_drive_thru = path === 'drive-thru'

  const allProducts = menu.flatMap((category) => category.products);
  const [categoryShowing, setCategoryShowing] = useState(
    menu.filter((category) =>
      is_drive_thru ? category.available_in_drive_thru : category.available
    )?.[0] || []
  );
  const [searchProduct, setSearchProduct] = useState('');
  const [isSelectingComplements, setIsSelectingComplements] = useState(false);
  const [productSelecting, setProductSelecting] = useState(null);
  const [modalErrorNF, setModalErrorNF] = useState(false);
  const [responseNfce, setResponseNfce] = useState(null);
  const [cashierOpen, setCashierOpen] = useState(false);

  const [clubInfo, setClubInfo] = useState({
    phone: '',
    date: '',
  });
  const [buyerName, setBuyerName] = useState(null);

  const toggleComplementArea = (product) => {
    setProductSelecting(product);
    setIsSelectingComplements(true);
  };

  const scannedBarcode = useBarcodeScanner();

  const [hasCodebar, setHasCodebar] = useState(false);

  const normalizeString = (str) =>
    str
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

  function handleSearchEanProduct(item) {
    if (item.length >= 3) {
      const filteredProducts = allProducts.filter(
        (product) =>
          product.name.toLowerCase().includes(item.toLowerCase()) ||
          product.ean_codes?.some(
            (ean) =>
              normalizeString(ean).includes(item.toLowerCase()) &&
              ean.length <= 7
          )
      );

      const searchResult = {
        name: `Buscando por: ${item}`,
        products: filteredProducts,
      };

      setCategoryShowing(searchResult);
    } else {
      setCategoryShowing(menu[0]);
    }
  }

  function handleSearchProduct(item) {
    if (item.length >= 3) {
      const filteredProducts = allProducts.filter(
        (product) =>
          product.name.toLowerCase().includes(item.toLowerCase()) ||
          product.ean_codes?.some((ean) =>
            normalizeString(ean).includes(item.toLowerCase())
          )
      );

      if (filteredProducts.length === 0 && user.ean_scale_code !== 'none') {
        searchScaleCode(item);
        return;
      }

      const searchResult = {
        name: `Buscando por: ${item}`,
        products: filteredProducts,
      };

      setCategoryShowing(searchResult);
    } else {
      setCategoryShowing(menu[0]);
    }
  }

  function searchScaleCode(code) {
    function extractScaleCode(barcode) {
      if (!barcode || barcode.length < 8) return null;

      const trimmed = barcode.slice(1);

      const scaleCode = trimmed.slice(0, 6);

      return scaleCode;
    }

    let newScannerBarcode = code;

    const extractedCode = extractScaleCode(scannedBarcode);
    if (extractedCode) {
      newScannerBarcode = extractedCode;
    }

    handleSearchEanProduct(newScannerBarcode);
  }

  useEffect(() => {
    if (scannedBarcode === '') {
      return;
    }

    setHasCodebar(true);

    const newScannerBarcode = scannedBarcode;

    handleSearchProduct(newScannerBarcode);
  }, [scannedBarcode, user]);

  // useEffect(() => {
  //   if (scannedBarcode === '') {
  //     handleSearchProduct('');
  //     setHasCodebar(false);
  //     return;
  //   }
  //   handleSearchProduct(scannedBarcode);

  //   setHasCodebar(true);
  // }, [scannedBarcode]);

  // useEffect(() => {

  // }, [searchProduct]);

  useEffect(() => {
    setCategoryShowing(
      menu.filter((category) =>
        is_drive_thru ? category.available_in_drive_thru : category.available
      )?.[0] || []
    );
  }, [menu, is_drive_thru]);

  useEffect(() => {
    closeCart();
  }, []);

  const { closeCart, cart } = useCart();
  const history = useHistory();

  useEffect(() => {
    if (cart.length > 0) {
      setPreventExit(true);
    } else {
      setPreventExit(false);
    }
  }, [cart]);

  const [preventExit, setPreventExit] = useState(false);
  const [modalAdvice, setModalAdvice] = useState(false);
  const [locationPath, setLocationPath] = useState('');

  function toggleModalAdvice() {
    setModalAdvice(!modalAdvice);
    setPreventExit(true);
  }

  useEffect(() => {
    const unblock = history.block((location) => {
      if (preventExit) {
        setModalAdvice(true);
        setPreventExit(false);
        setLocationPath(location.pathname);
        return false;
      }
      return true;
    });

    return () => {
      unblock();
    };
  }, [history, preventExit]);

  function confirmCloseCart() {
    toggleModalAdvice();
    closeCart();
    history.push(locationPath);
  }

  const areaRef = useRef(null);

  const paymentProps = {
    currentPaymentFlow,
    handleBalconyOrder,
    setResponseNfce,
    setModalErrorNF,
    clubInfo,
    setClubInfo,
    buyerName,
    setBuyerName,
    is_drive_thru,
    balconySession,
    savePaymentAsync,
    onCloseTableBill: handleCloseTableBill,
    getTableId,
    tableId,
    handleStartPinpadPayment,
    pinpadHealthStatus,
    pinpadPaymentStatus,
    handleCancelPinpadPayment,
    handleResetPinpadOperation,
    handleSwitchPinpadCancelStatus,
    handleChoosePayWithPinpad,
    isChoosePinpad,
    isLeavingPayment,
    isLoadingPayment,
    handleUpdateCashbackValue
  };

  return (
    <>
      <ModalConfirmation
        isOpen={modalAdvice}
        toggle={toggleModalAdvice}
        confirm={confirmCloseCart}
        confirmText="Sim, sair e excluir o carrinho"
        cancel={toggleModalAdvice}
        cancelText="Irei fazer o pedido"
        title="Você possui itens no carrinho. Tem certeza que deseja sair sem fazer o pedido?"
      />
      <NewHeader />
      <PageContainer ref={areaRef}>
        <BalconyCard>
          {isSelectingComplements ? (
            <SelectComplements
              product={productSelecting}
              setIsSelectingComplements={setIsSelectingComplements}
            />
          ) : (
            <>
              <MenuArea onClick={() => {
                if (isBalconyProductsBlocked) {
                  toast.error('Não é possível alterar o pedido durante o pagamento.');
                }
              }}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 10,
                    pointerEvents: isBalconyProductsBlocked && 'none',
                    filter: isBalconyProductsBlocked && 'blur(4px)',
                    cursor: isBalconyProductsBlocked && 'not-allowed',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <div>
                      {isBalconyProductsBlocked ? <div style={{
                        cursor: 'pointer'
                      }} onClick={() => {
                        toast.error('Não é possível retornar à operação com um pedido em andamento');
                      }}>
                        <IoIosArrowBack />
                        <span>Mesas</span>
                      </div> : <BackLink to="/operation">
                        <IoIosArrowBack />
                        <span>Mesas</span>
                      </BackLink>}
                      <h3>Categorias</h3>
                    </div>
                    <div
                      style={{ display: 'flex', gap: 10, alignItems: 'center' }}
                    >
                      <GetDemoButton url="https://app.getdemo.com.br/d/67bcbd60-be33-4120-8478-725d32dc9fe4" />
                      <IconInput
                        color="#cdcdcd"
                        icon={<FaSearch color="#cdcdcd" />}
                        deleteIcon={<FaTimes color="#cdcdcd" />}
                        isClearable
                        deleteButton={() => {
                          handleSearchProduct('');
                          setSearchProduct('');
                        }}
                        containerStyles={{
                          width: 300,
                          height: 30,
                          padding: '0px 10px',
                        }}
                        placeholder="Buscar"
                        value={searchProduct}
                        onChange={(e) => {
                          handleSearchProduct(e.target.value);
                          setSearchProduct(e.target.value);
                        }}
                      />
                    </div>

                    <Button
                      title="Ver Caixa"
                      icon={<FaCashRegister />}
                      buttonColor="#2EC9B7"
                      style={{ height: 30, padding: '0px 10px' }}
                      onClick={() => setCashierOpen(true)}
                    />
                  </div>
                  <Categories
                    setCategoryShowing={setCategoryShowing}
                    is_drive_thru={is_drive_thru}
                  />
                </div>
                <div style={{
                  pointerEvents: isBalconyProductsBlocked && 'none',
                  filter: isBalconyProductsBlocked && 'blur(4px)',
                  cursor: isBalconyProductsBlocked && 'not-allowed',
                }}>
                  <h3>{categoryShowing?.name}</h3>
                  <div
                    onClick={(e) => {
                      if (isBalconyProductsBlocked) {
                        toast.error('Não é possível adicionar novos pedidos durante o pagamento.');
                        e.stopPropagation();
                      }
                    }}
                  >
                    <BalconyProducts
                      products={categoryShowing?.products}
                      toggleComplementArea={toggleComplementArea}
                      hasCodebar={hasCodebar}
                      setHasCodebar={setHasCodebar}
                      scannedBarcode={scannedBarcode}
                      is_drive_thru={is_drive_thru}
                      areaRef={areaRef}
                    />
                  </div>
                </div>
              </MenuArea>

              <PaymentArea>
                {isBalconyPinpad ?
                  <BalconyPaymentAreaPinpad
                    {...balconyProps}
                    {...paymentProps}
                    handleSubmitRefactoryOrderBasket={handleSubmitRefactoryOrderBasket}
                    handleCancelPaymentCancelation={handleCancelPaymentCancelation}
                    handleSelectedPaymentComponent={handleSelectedPaymentComponent}
                    isSelectedPaymentComponent={isSelectedPaymentComponent}
                    isOpenBackToOrder={isOpenBackToOrder}
                    paymentsData={paymentsData}
                    getPayments={getPayments}
                  /> : <BalconyPaymentArea {...paymentProps} />
                }
              </PaymentArea>
            </>
          )}
        </BalconyCard>

        <ModalCashier isOpen={cashierOpen} toggle={() => setCashierOpen(false)}>
          <h2>Caixa</h2>
          <OpeningBox channel="balcony" />
        </ModalCashier>

        <ModalErrorNF
          isOpen={modalErrorNF}
          toggle={() => setModalErrorNF((state) => !state)}
        >
          <h2>
            Ocorreu um erro ao tentar emitir a Nota Fiscal. Corrija-o e tente
            novamente!
          </h2>
          <p>Erro(s):</p>
          {responseNfce?.status_sefaz === '100' ? (
            <p style={{ color: 'green' }}>
              Mensagem SEFAZ: {responseNfce?.mensagem_sefaz}
            </p>
          ) : (
            <div style={{ color: 'red' }}>
              <p style={{ color: 'red' }}>
                Mensagem SEFAZ:{' '}
                {responseNfce?.response
                  ? responseNfce?.response.mensagem
                  : responseNfce?.mensagem_sefaz}
              </p>
              {responseNfce?.response &&
                responseNfce?.response.codigo === 'erro_validacao_schema' &&
                responseNfce?.response.erros &&
                responseNfce?.response.erros.map((e) => <p> - {e.mensagem}</p>)}
            </div>
          )}
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Hyperlink
              fontSize={16}
              textDecoration="underline"
              href="/operation/bills?isCompleted=true"
              onClick={() => setModalErrorNF(false)}
            >
              Ver comandas finalizadas
            </Hyperlink>
            <Button
              title="Ok"
              buttonColor="#2ec9b7"
              onClick={() => setModalErrorNF(false)}
            />
          </div>
        </ModalErrorNF>
      </PageContainer>
    </>
  );
};

export default BalconyPage;
